import { defineStore } from "pinia";

export const mdmServerStore = defineStore("mdmServer", {
  state: () => ({
    selected: {},
  }),
});
